/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S31_Item_4Inputs */

const es_privacy_policy_data_collected_s31_item_4 = /** @type {(inputs: Privacy_Policy_Data_Collected_S31_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens de acceso y refresco OAuth 2.0 (almacenados cifrados)`)
};

const en_privacy_policy_data_collected_s31_item_4 = /** @type {(inputs: Privacy_Policy_Data_Collected_S31_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2.0 access and refresh tokens (stored encrypted)`)
};

/**
* | output |
* | --- |
* | "OAuth 2.0 access and refresh tokens (stored encrypted)" |
*
* @param {Privacy_Policy_Data_Collected_S31_Item_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s31_item_4 = /** @type {((inputs?: Privacy_Policy_Data_Collected_S31_Item_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S31_Item_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s31_item_4(inputs)
	return en_privacy_policy_data_collected_s31_item_4(inputs)
});
export { privacy_policy_data_collected_s31_item_4 as "privacy_policy.data_collected.s31_item_4" }